import { render, staticRenderFns } from "./SkuNormalSetting.vue?vue&type=template&id=310240ac&scoped=true"
import script from "./SkuNormalSetting.vue?vue&type=script&lang=js"
export * from "./SkuNormalSetting.vue?vue&type=script&lang=js"
import style0 from "./SkuNormalSetting.vue?vue&type=style&index=0&id=310240ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310240ac",
  null
  
)

export default component.exports